import { render, staticRenderFns } from "./TextNotice.vue?vue&type=template&id=62e74a23&scoped=true"
import script from "./TextNotice.vue?vue&type=script&lang=ts"
export * from "./TextNotice.vue?vue&type=script&lang=ts"
import style0 from "./TextNotice.vue?vue&type=style&index=0&id=62e74a23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e74a23",
  null
  
)

export default component.exports